const blogConstantsAr = {
  thumbnail: 'رابط الصورة المصغرة',
  publishSwitch: 'منشور',
  minutesOfReading: 'الوقت اللازم للقراءة',
  minutesOfReadingValidation: 'الرجاء إدخال رقم أكبر من 0',
  blogARTags: 'الوسوم بالعربية',
  blogENTags: 'الوسوم بالإنجليزية',
  thumbnailValidation: 'الرجاء إدخال رابط الصورة المصغرة',
  editBlog: 'تعديل المدونة',
  newBlog: 'إضافة مدونة',
  createdBlogSnackbar: 'تم إنشاء مدونة بنجاح',
  updatedBlogSnackbar: 'تم تحديث المدونة بنجاح',
  arabic:'العربية',
  english:'الإنجليزية',
  englishAndArabic:"الإنجليزية والعربية",
  published:'منشور',
  unPublished:'غير منشور'
};

export default blogConstantsAr;
